import moment from 'moment';

export function resolveDeviceOid(markerValue) {
    return markerValue?.deviceOid || markerValue?._id || markerValue?.id || null;
}

/** Map GET /devices row → router state for Configuration page (matches AssetsDevice table row shape). */
export function mapDeviceToConfigurationState(device) {
    if (!device) {
        return null;
    }

    const hasLastUpdated = device.lastUpdated != null;
    const lastUpdatedMoment = hasLastUpdated ? moment(device.lastUpdated) : null;

    let vehiclePresetId = '';
    if (device.vehiclePresetId) {
        vehiclePresetId = (typeof device.vehiclePresetId === 'object' && device.vehiclePresetId.oid)
            ? { oid: device.vehiclePresetId.oid, name: device.vehiclePresetId.name }
            : device.vehiclePresetId;
    }

    return {
        id: device.oid,
        deviceSN: device.deviceSerial,
        assetName: device.assetName !== null ? device.assetName : null,
        assetType: device.assetType ? [device.assetType] : [],
        fuelSource: device.fuelSource || '',
        mileageSource: device.mileageSource || '',
        fuelCapacity: device.fuelCapacity || '',
        vehiclePresetId,
        vehiclePreset: device.vehiclePreset || null,
        batteryMappingPreference: device.batteryMappingPreference || '',
        starterBatteryConfigId: device.starterBatteryConfigId || '',
        batteryOneConfigId: device.batteryOneConfigId || '',
        batteryTwoConfigId: device.batteryTwoConfigId || '',
        tags: device.tags !== undefined ? device.tags : [],
        sim: device.sim || {},
        dataUsage: {
            usage: device.dataUsage !== null ? device.dataUsage : null,
            limit: device.dataLimit,
        },
        lastUpdated: {
            date: hasLastUpdated ? lastUpdatedMoment.format('DD MMM YYYY') : null,
            time: hasLastUpdated
                ? `${lastUpdatedMoment.format('h:mm:ssa')} GMT${lastUpdatedMoment.format('ZZ').replace('00', '').replace('0', '')}`
                : null,
        },
        description: device.description || '',
    };
}
